"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Modal_1 = require("./UI/Modal");
var Map_1 = require("./UI/Map");
var Location_1 = require("./Utility/Location");
var PlaceFinder = /** @class */ (function () {
    function PlaceFinder() {
        var _this = this;
        this.locateUserHandler = function () {
            if (!navigator.geolocation) {
                alert('Location feature is not available in your browser - please use a more modern browser or manually enter an address.');
                return;
            }
            var modal = new Modal_1.Modal('loading-modal-content', 'Loading location - please wait');
            modal.show();
            navigator.geolocation.getCurrentPosition(function (successResult) { return __awaiter(_this, void 0, void 0, function () {
                var coordinates, address;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            coordinates = {
                                lat: successResult.coords.latitude,
                                lng: successResult.coords.longitude,
                            };
                            return [4 /*yield*/, Location_1.getAddressFromCoords(coordinates)];
                        case 1:
                            address = _a.sent();
                            modal.hide();
                            this.selectPlace(coordinates, address);
                            return [2 /*return*/];
                    }
                });
            }); }, function (error) {
                modal.hide();
                alert('Could not locate you unfortunately. Plese, enter an address manually!' + '\n' + error);
            });
        };
        var addressForm = document.querySelector('form');
        var locateUserBtn = document.getElementById('locate-btn');
        this.shareBtn = document.getElementById('share-btn');
        addressForm.addEventListener('submit', this.findAddresHandler.bind(this));
        locateUserBtn.addEventListener('click', this.locateUserHandler.bind(this));
        this.shareBtn.addEventListener('click', this.sharePlaceHandler);
    }
    PlaceFinder.prototype.sharePlaceHandler = function () {
        var sharedLinkInputElement = document.getElementById('share-link');
        if (!(navigator.clipboard) && sharedLinkInputElement) {
            sharedLinkInputElement.select();
            return;
        }
        navigator.clipboard.writeText(sharedLinkInputElement.value).
            then(function () {
            alert('Copied into clipboard!');
        }).catch(function (error) {
            console.log(error);
            sharedLinkInputElement.select();
        });
    };
    PlaceFinder.prototype.selectPlace = function (coordinates, address) {
        if (this.map) {
            this.map.render(coordinates);
        }
        else {
            this.map = new Map_1.Map(coordinates);
        }
        this.shareBtn.disabled = false;
        var sharedLinkInputElement = document.getElementById('share-link');
        sharedLinkInputElement.value = location.origin + "/myplace?address=" + encodeURI(address) + "&lat=" + coordinates.lat + "&lng=" + coordinates.lng;
    };
    PlaceFinder.prototype.findAddresHandler = function (event) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var form, address, modal, coordinates, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!event.target) return [3 /*break*/, 5];
                        event.preventDefault();
                        form = event.target;
                        address = (_a = form.querySelector('input')) === null || _a === void 0 ? void 0 : _a.value;
                        if (!address || address.trim().length === 0) {
                            alert('Invalid address entered - please try again!');
                            return [2 /*return*/];
                        }
                        modal = new Modal_1.Modal('loading-modal-content', 'Loading location, please wait.');
                        modal.show();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, Location_1.getCoordsFromAddress(address)];
                    case 2:
                        coordinates = _b.sent();
                        this.selectPlace(coordinates, address);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _b.sent();
                        alert(error_1.message);
                        return [3 /*break*/, 4];
                    case 4:
                        modal.hide();
                        _b.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return PlaceFinder;
}());
new PlaceFinder();
